import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";

export function EnergyAccessKasese() {
  return (
    <div className="art-page">
      <SEO
        title="Energy Access Baseline Study — Kasese District"
        description="CIRCODU conducted a comprehensive energy access baseline for Kasese District through household surveys, institutional assessments, SME surveys, and key informant interviews, documenting energy access across sectors."
        keywords="energy access, baseline study, Kasese District, household survey, institutional assessment, SME survey, key informant interviews, focus group discussions, energy use patterns, biomass fuel dependence, renewable energy awareness, WWF Uganda, CIRCODU, energy access baseline Uganda, Kasese energy access, household energy use Uganda, institutional energy use Uganda, SME energy use Uganda, key informant interviews Uganda, focus group discussions Uganda"
        url="/Energy-Access-Baseline-Study-Kasese-District"
        datePublished="2013-11-01"
      />

      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Energy Access Baseline Study — Kasese District
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>
      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              November 01, 2013
            </div>
            <h1 className="art-title">
              Energy Access Baseline Study — Kasese District
            </h1>
            <div className="texty">
              <h2 className="art-subheading">Overview</h2>
              <p>
                In 2012 and 2013, CIRCODU conducted a comprehensive energy
                access baseline study for Kasese District in western Uganda,
                commissioned by <strong>WWF Uganda Country Office (UCO)</strong>{" "}
                to support the design and monitoring of its energy programmes in
                the region. Kasese District, located at the foot of the Rwenzori
                Mountains and bordering the Democratic Republic of Congo,
                presents a distinctive energy access context — sitting within
                one of Africa's most ecologically sensitive landscapes while
                experiencing high dependence on biomass fuels that continue to
                exert pressure on its forests and wetlands.
              </p>
              <h2 className="art-subheading">CIRCODU's Role</h2>
              <p>
                CIRCODU deployed a mixed-methods research approach across
                multiple institutional and community levels:
              </p>
              <ol>
                <li>
                  <strong>Household surveys</strong> to quantify energy access
                  levels, fuel use patterns, and cooking technology prevalence
                  across the district.
                </li>
                <li>
                  <strong>Institutional surveys</strong> covering schools,
                  health facilities, and other public institutions to capture
                  the energy needs and cooking arrangements of major public
                  service providers.
                </li>
                <li>
                  <strong>SME and industry surveys</strong> documenting the
                  commercial energy landscape in trading centres and processing
                  enterprises.
                </li>
                <li>
                  <strong>
                    Key informant interviews and focus group discussions
                  </strong>{" "}
                  adding qualitative depth — capturing community perspectives on
                  energy needs, barriers to adopting cleaner technologies, and
                  awareness of renewable energy options.
                </li>
              </ol>
              <p>
                The resulting baseline provided WWF UCO with the benchmarking
                data needed to set measurable targets, design appropriate
                interventions, and track progress across its energy programming
                portfolio in the district.
              </p>
            </div>
            <div className="art-cta">
              <p>
                For more information about CIRCODU's energy access research,
                contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>
            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
